<template>
  <div id="app" :class="searchRoute ? 'searchRout' : '' ">
    <div v-show="shareValue">
      <!-- 个人中心+发布页面+天地图h5页面不展示分享功能 -->
      <p class="social-share" data-sites="qzone,qq,weibo,wechat"></p>
    </div>
    <template v-if="showHeader">
      <v-header></v-header>
    </template>
    <router-view/>
  </div>
</template>

<script>
import '@/assets/js/jquery.share.min.js'
import '@/assets/js/share.min.css'
import vHeader from '@/components/common/HeaderArea'
import sign from '@/auth/sign'
export default {
  name: 'App',
  data () {
    return {
      appid: 'wzwebapp',
      timestamp: parseInt(new Date().getTime() / 1000),
      shareValue: !(location.href.indexOf('/user') > -1 || location.href.indexOf('/release') > -1 || location.href.indexOf('/tiandituh5') > -1),
      showHeader: !(location.href.indexOf('/tiandituh5') > -1),
      searchRoute: false
    }
  },
  components: {
    vHeader
  },
  watch: {
    '$route' () {
      this.shareValue = !(this.$route.path.indexOf('/user') > -1 || this.$route.path.indexOf('/release') > -1 || location.href.indexOf('/tiandituh5') > -1)
      this.searchRoute = this.$route.name === 'Search'
    }
  },
  created () {
    // 生成sign
    let oneParams = {
      appid: this.appid,
      timestamp: this.timestamp
    }
    let signO = sign(oneParams)
    // 传递的参数
    oneParams.sign = signO
    this.$store.dispatch('ALLTYPE', oneParams)
    this.$store.dispatch('ONETYPE', oneParams)
  }
  // mounted () {
  //   let oneParams = {
  //     appid: this.appid,
  //     timestamp: this.timestamp
  //   }
  //   let signO = sign(oneParams)
  //   // 传递的参数
  //   oneParams.sign = signO
  //   this.$store.dispatch('DAOHANGTYPE', oneParams)
  // }
}
</script>

<style scoped>
#app{
  overflow: hidden;
}
.searchRout {
  position: fixed;
  width: 100%;
  max-height: calc(100% - 150px);
  overflow-y: auto!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue